module.exports = __webpack_public_path__ + "img/blobfish.97e4c6b.png";